export const types = {
  SET_TAB_BAR_VISIBLE: 'SET_TAB_BAR_VISIBLE'
};

export interface State {
  bottomTabBarVisible: boolean
}